<template>
  <paper
    class="card-info"
    :tabbed="!showTitle"
  >
    <template
      v-if="showTitle"
      v-slot:title
    >
      <p class="mb-0">
        CPU
      </p>
    </template>
    <div class="row">
      <input-field
        label="CPU Name"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.cpuName || '-' }}
      </input-field>
      <input-field
        label="CPU Max Clock Speed"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{
          host.cpuMaxClockSpeed ? host.cpuMaxClockSpeed.toLocaleString() : '-'
        }}
      </input-field>
      <input-field
        label="CPU Manufacturer"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.cpuManufacturer || '-' }}
      </input-field>
      <input-field
        label="CPU Number Of Cores"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.cpuNumberOfCores || '-' }}
      </input-field>
      <input-field
        label="CPU Number Of Logical Processors"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.cpuNumberOfLogicalProcessors || '-' }}
      </input-field>
      <input-field
        label="CPU L2 Cache Size"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ formatBytes(cpuL2CacheSize) }}
      </input-field>
      <input-field
        label="CPU L3 Cache Size"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ formatBytes(host.cpuL3CacheSize) }}
      </input-field>
      <input-field
        label="CPU Socket Designation"
        label-position="top"
        class="px-1 col-12 col-sm-6"
      >
        {{ host.cpuSocketDesignation || '-' }}
      </input-field>
    </div>
  </paper>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'

export default {
  name: 'CPUInfo',
  components: { Paper },
  props: {
    host: {
      type: Object,
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cpuL2CacheSize() {
      return this.host.cpuL2CacheSize ? this.host.cpuL2CacheSize : 0
    },
    cpuL3CacheSize() {
      return this.host.cpuL3CacheSize ? this.host.cpuL3CacheSize : 0
    },
  },
}
</script>
